module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 17340,
			"name": "Game Development and Design",
			"url": "https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin",
			"price_from": 150
		},
		{
			"id": 9740,
			"name": "Mobile-Friendly Redesign for a WordPress Site",
			"url": "https://studio.envato.com/explore/mobile-design-development/9740-make-wordpress-existing-site-mobile-responsive",
			"price_from": 150
		},
		{
			"id": 9320,
			"name": "Android UI/UX App Design",
			"url": "https://studio.envato.com/explore/app-design/9320-android-ui-ux-app-design-or-android-xml-layout",
			"price_from": 200
		},
		{
			"id": 14553,
			"name": "Slider (Carousel) Banners",
			"url": "https://studio.envato.com/explore/web-banner-design/14553-slider-carousel-banners",
			"price_from": 55
		},
		{
			"id": 8155,
			"name": "3D Rendering Service",
			"url": "https://studio.envato.com/explore/3d-design-modeling/8155-3d-rendering",
			"price_from": 120
		},
		{
			"id": 8374,
			"name": "Professional High-Quality Infographics Design",
			"url": "https://studio.envato.com/explore/infographic-design/8374-professional-high-quality-infographics-design",
			"price_from": 250
		},
		{
			"id": 1453,
			"name": "Effective Web Banner Design",
			"url": "https://studio.envato.com/explore/web-banner-design/1453-effective-web-banner-design",
			"price_from": 55
		},
		{
			"id": 2017,
			"name": "3D Logo Design",
			"url": "https://studio.envato.com/explore/3d-design-modeling/2017-3d-logo-design",
			"price_from": 200
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/3docean.json
// module id = 232
// module chunks = 1 2